import { TableData } from "@/dto/tableData";
import { ScanToOrderCartTableInfo } from "./scanToOrderCartTableInfo";
import { DoubleCheckOrderBanner } from "@/components/banners/doubleCheckOrderBanner";
import { AlreadySentToKitchenSection } from "./alreadySentToKitchenSection";
import { CurrentItemsSection } from "./currentItemsSection";
import { RetailCartItem } from "@/dto/retailCartItem";
import { ModalSpecialInstructions } from "@/components/modalSpecialInstructions/modalSpecialInstructions";
import { OrderType } from "@/types";
import { ErrorBanner } from "@/components/banners/errorBanner";

export interface ScanToOrderCartContentProps {
  showSpecialInstructions: boolean;
  setShowSpecialInstructions: (value: boolean) => void;
  merchantColor: string;
  setSpecialInstructions: (value: string) => void;
  tableData: TableData;
  cartItems: RetailCartItem[];
  removeFromCart: (event: React.MouseEvent, index: number) => void;
  orderType: OrderType;
  isCartEmpty: boolean;
  isRunningTabsEnabled: boolean;
  failedToSendToKitchen: boolean;
  onRequestClose: () => void;
  specialInstructions: string;
  isBusinessClosed: boolean;
}
export const ScanToOrderCartContent = ({
  showSpecialInstructions,
  setShowSpecialInstructions,
  merchantColor,
  setSpecialInstructions,
  tableData,
  cartItems,
  removeFromCart,
  orderType,
  isCartEmpty,
  isRunningTabsEnabled,
  failedToSendToKitchen,
  specialInstructions,
  onRequestClose,
  isBusinessClosed,
}: ScanToOrderCartContentProps) => {
  const itemsSentToKitchen = tableData?.order?.cart?.items;
  return (
    <div
      data-test-id="scan-to-order-cart-content"
      className="flex h-full flex-col overflow-auto"
    >
      <ScanToOrderCartTableInfo
        tableName={tableData.name}
        orderType={orderType}
      />
      <>
        {!isBusinessClosed && !failedToSendToKitchen && (
          <DoubleCheckOrderBanner />
        )}
        {failedToSendToKitchen && (
          <ErrorBanner text="Couldn't send your order to the kitchen. Contact a server." />
        )}
        <ModalSpecialInstructions
          className="pt-8 mx-4"
          showSpecialInstructions={showSpecialInstructions}
          setShowSpecialInstructions={setShowSpecialInstructions}
          merchantColor={merchantColor}
          setSpecialInstructions={setSpecialInstructions}
          specialInstructions={specialInstructions}
        />
      </>
      <div className="flex-1 overflow-auto">
        {!isCartEmpty && (
          <CurrentItemsSection
            removeFromCart={removeFromCart}
            cartItems={cartItems}
            onRequestClose={onRequestClose}
          />
        )}
        {itemsSentToKitchen?.length > 0 && isRunningTabsEnabled && (
          <AlreadySentToKitchenSection
            items={itemsSentToKitchen}
            onRequestClose={onRequestClose}
          />
        )}
      </div>
    </div>
  );
};
